import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logos/full-logo-white.svg";
import { socialmedias, footerLinks } from "./data";
import { MdEmail } from "react-icons/md";
import { GoDeviceMobile } from "react-icons/go";
import { BsArrowRight } from "react-icons/bs";
import ChooseLanguage from "../ChooseLanguage/chooseLanguage";
import { ToggleView } from "./ToggleView.jsx";
import MobileFooter from "./MobileFooter";
const Footer = (props) => {
  return (
    <div className="footer">
      <div className="first-section">
        <img src={logo} alt="hostai logo" />
        <div className="logos-section">
          <ul>
            {socialmedias.map((list) => {
              return (
                <li>
                  <Link to={props.to} className="social-link">
                    <div className="icon">{list.icon}</div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <Link className="get-started-button" to="./">
          Get started
          <BsArrowRight className="arrow" />
        </Link>
      </div>
      <MobileFooter />

      <div className="middle-section">
        {footerLinks.map((l) => (
          <LinkCategory key={l.category} {...l} />
        ))}
      </div>
      <div className="last-section">
        <h4>@HostAI INC, 2021, All rights are reserved.</h4>
        <div className="middle">
          <p className="email-p">
            <MdEmail className="email" />
            support@hostai.com
          </p>
          <p className="mobile-p">
            <GoDeviceMobile className="mobile" />
            +32221115
          </p>
          <ChooseLanguage
            setLanguage={props.setLanguage}
            language={props.language}
          />
          <div className="toggle">
            <ToggleView />
          </div>
        </div>
        <div className="links">
          <Link className="last-links" to="/termsofservice">
            Terms of Service
          </Link>
          <Link className="last-links" to="/contact">
            Contact Us
          </Link>
          <Link className="last-links" to="/privacypolicy">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

const LinkCategory = (props) => {
  return (
    <div className="link-category">
      <span className="paragraph-3">{props.category}</span>

      <div className="links">
        {props.links.map((l) => {
          return (
            <Link key={l.to} to={l.to} className="footer-link">
              {l.link}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
export default Footer;
